import { openApi } from '@/api/request'

export default {
  getShoppingCart (requestData) {
    const url = `/Rccl.OpenApi/Booking/GetAllShoppingCart`
    return openApi.post(url, requestData)
  },
  getShoppingCartCount (requestData) {
    const url = `/Rccl.OpenApi/Booking/GetAllShoppingCartCount`
    return openApi.post(url, requestData)
  },
  addShoppingCart (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/AddShoppingCartHP', requestData)
  },
  deleteShoppingCart (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/DeleteStateroomByCruiseApi', requestData)
  },
  deleteShoppingCartCruise (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/HPDeleteShoppingCartCruiseApi', requestData)
  },
  initStateroom (bookingKey) {
    return openApi.get('/Rccl.OpenApi/Booking/InitStateroomHP', {
      params: {
        bookingKey: bookingKey,
        v: (new Date()).getTime()
      }
    })
  },
  selectStateroom (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/SelectStateroomHP', requestData)
  },
  guestInfoApi (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/GuestInfoHPApi', requestData)
  },
  addBookingCotact (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/AddContactHP', requestData)
  },
  addBookingGuests (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/AddGuestByViewModelHP', requestData)
  },
  getCabins (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/StateroomForCategoryApi', requestData)
  },
  changeStateroomNumber(requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/ChangeStateroomNumberHP', requestData)
  },
  updateCouponCode (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/UpdateCouponHPApi', requestData)
  },
  checkGuestRepeatHp (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/CheckGuestRepeatHp', requestData)
  },
  submitBooking (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/SubmitBookingHP', requestData)
  },
  checkGuest (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/CheckGuestHP', requestData)
  },
  checkCoupon (requestData) {
    return openApi.post('/Rccl.OpenApi/CouponApi/CheckCoupon', requestData)
  },
  refreshLockStateroom (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/RefreshLockStateroomHP', requestData)
  },
  paymentPage (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Booking/PayHP', {
      params: requestData
    })
  },
  giveUserCoupon (requestData) {
    return openApi.post('/Rccl.OpenApi/CouponApi/GiveUserCouponApi', requestData)
  },
  getOneShoppingCart (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/GetOneShoppingCart', requestData)
  },
  payByMethodHP (requestData) {
    return openApi.post('/Rccl.OpenApi/Pay/PayByMethodHP', requestData)
  },
  checkPaid (requestData) {
    return openApi.post('/Rccl.OpenApi/Pay/CheckPaidByPaymentId', requestData)
  },
  paySuccess (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Booking/PaySuccess', {
      params: requestData
    })
  },
  paySuccessV2 (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Booking/PaySuccessV2', {
      params: requestData
    })
  },
  selectShorex (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/ChooseShorexGuiderByBookings', requestData)
  },
  selectShorexV2 (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/ChooseShorexGuiderByBookingsV2', requestData)
  },
  bookingSearch (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/BookingSearchApi', requestData)
  },
  bookingDetail (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Booking/BookingDetailHP', {
      params: requestData
    })
  },
  bookingList (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/HomePortUserCenterBookingListHP', requestData)
  },
  openBookingDetail (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/OpenBooking/Detail', {
      params: requestData
    })
  },
  openBookingPay (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/OpenBooking/Pay', {
      params: requestData
    })
  },
  openBookingSubmitPay (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/OpenBooking/PayByMethod', {
      params: requestData
    })
  },
  changeBookingContact (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/ModifyBookingContactHPApi', requestData)
  },
  updateBookingGuest ({id, passPortNum, passPortExpirationDate, updateFields}) {
    return openApi.post('/Rccl.OpenApi/Booking/updateBookingGuest', {
      id, passPortNum, passPortExpirationDate, updateFields
    })
  },
  updateSpecialBooking(requestData){
    return openApi.post('/Rccl.OpenApi/Booking/UpdateSpecialBookingHPApi',requestData)
  },
  updateGuests(requestData){
    return openApi.post('/Rccl.OpenApi/Booking/UpdateGuests',requestData)
  },
  getPolicyContentList(requestData,params){
    return openApi.post('/Rccl.OpenApi/Cruise/GetBookingPolicyContentList',requestData,{
      params: params
    })
  },
  getPayBookingState(requestData){
    return openApi.post('/Rccl.OpenApi/Booking/PostRetrieveBookingByBookingRecordId',requestData)
  },
  submitInvoice(requestData){
    return openApi.post('/Rccl.OpenApi/InvoiceApplyOrder/ApplyInvoice',requestData)
  },
  getCompanyList(requestData){
    return openApi.get('/Rccl.OpenApi/InvoiceApplyOrder/InvoiceAutoMatchCompany',{
      params: requestData
    })
  },
  getBookingAmount(requestData){
    return openApi.post('/Rccl.OpenApi/InvoiceApplyOrder/GetBookingRecordInvoiceAmount',requestData)
  },
  getBookingRecordInvoice(requestData){
    return openApi.post('/Rccl.OpenApi/InvoiceApplyOrder/GetUserInvoiceApplyDetail',requestData)
  },
  resendInvoice(requestData){
    return openApi.post('/Rccl.OpenApi/InvoiceApplyOrder/resendInvoice',requestData)
  },
  getUserInvoiceApplyList(requestData){
    return openApi.get('/Rccl.OpenApi/InvoiceApplyOrder/GetUserInvoiceApplyList',{
      params: requestData
    })
  },
  getInvoiceBookingList(requestData){
  return openApi.post('/Rccl.OpenApi/InvoiceApplyOrder/InvoiceUserBookingList', requestData)
  },
  getWxQrCode(requestData){
    return openApi.post('/Rccl.OpenApi/StateroomUpgradeApi/GetBookingDetailWxQrCode',requestData)
  },
  addContactNew(requestData){
  return openApi.post('/Rccl.OpenApi/Booking/AddContactApi', requestData)
},
  getRouteDetailCoupons(requestData){
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseDetailCouponInfos', {
      params: requestData
    })
  },
  getCruisePortsDetail (requestData) {
    requestData.v = (new Date()).getTime()
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruisePortsDetail', {
      params: requestData
    })
  }
}
